/* cart-furleza.js — real-cart patch for PATTE controller. Loaded after theme.js. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function patchPATTE() {
    if (!window.PATTE) {
      setTimeout(patchPATTE, 200);
      return;
    }

    var P = window.PATTE;

    /* thresholds from data-* on #cartDrawer */
    var drawer = document.getElementById('cartDrawer');
    var SHIP = drawer ? parseInt(drawer.dataset.ship    || '5900', 10) : 5900;
    var BMIN = drawer ? parseInt(drawer.dataset.bundleMin || '2',  10) : 2;
    var BPCT = drawer ? parseFloat(drawer.dataset.bundlePct || '0.10')  : 0.10;

    function money(cents) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    /* subtotal / count from real cart */
    P._subtotal = function () {
      return (this.cart || []).reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
    };

    P._itemCount = function () {
      return (this.cart || []).reduce(function (s, i) { return s + i.quantity; }, 0);
    };

    /* quantity change via Shopify change.js */
    P.setQty = function (lineKey, qty) {
      var self = this;
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        self.cart = cart.items || [];
        self._syncBadge();
        self._renderCart();
      })
      .catch(function (e) {});
    };

    P._changeQty = function (lineKey, delta) {
      var item = (this.cart || []).find(function (i) { return i.key === lineKey; });
      if (!item) return;
      this.setQty(lineKey, Math.max(0, item.quantity + delta));
    };

    /* badge sync */
    P._syncBadge = function () {
      var n = this._itemCount();
      document.querySelectorAll('#cartCount').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
      var tc = document.getElementById('cartTitleCount');
      if (tc) tc.textContent = '(' + n + ')';
    };

    /* rewards bar */
    P.computeRewards = function () {
      var sub  = this._subtotal();
      var left = Math.max(0, SHIP - sub);
      var pct  = Math.min(100, Math.round((sub / SHIP) * 100));
      var msg, done;
      if (sub === 0) {
        msg  = 'Besteed <strong>' + money(SHIP) + '</strong> voor gratis verzending 🐾';
        done = false;
      } else if (left > 0) {
        msg  = 'Nog <strong>' + money(left) + '</strong> en je verzending is gratis 🐾';
        done = false;
      } else {
        msg  = '<strong>Gelukt! Gratis verzending 🎉</strong>';
        done = true;
      }
      return { pct: pct, msg: msg, done: done };
    };

    P.computeShipping  = function () { return this._subtotal() >= SHIP ? 0 : 490; };
    P.computeDiscount  = function () { return this._itemCount() >= BMIN ? Math.round(this._subtotal() * BPCT) : 0; };
    P.computeTotal     = function () { return this._subtotal() - this.computeDiscount() + this.computeShipping(); };

    /* main updateCartUI */
    P.updateCartUI = function () {
      this._syncBadge();
      this._renderCart();
    };

    /* full drawer render */
    P._renderCart = function () {
      var self  = this;
      var items = this.cart || [];

      /* rewards */
      var rEl = document.getElementById('cartRewards');
      if (rEl) {
        var r = this.computeRewards();
        rEl.innerHTML =
          '<p class="cart-rewards__msg">' + r.msg + '</p>' +
          '<div class="cart-progress' + (r.done ? ' cart-progress--done' : '') + '">' +
            '<div class="cart-progress__fill" style="width:' + r.pct + '%">' +
              (r.done ? '<span class="cp-check">✓</span>' : '') +
            '</div>' +
          '</div>';
      }

      /* items */
      var iEl = document.getElementById('cartItems');
      if (iEl) {
        iEl.innerHTML = items.length === 0
          ? self._renderEmptyCart()
          : items.map(function (it) { return self._renderRealItem(it); }).join('');
      }

      /* foot */
      var fEl = document.getElementById('cartFoot');
      if (fEl) {
        fEl.innerHTML = items.length > 0 ? self._renderFoot() : '';
      }

      this._renderUpsell();
    };

    /* single item row */
    P._renderRealItem = function (item) {
      var key   = item.key;
      var vt    = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var sub   = item.price * item.quantity;
      var orig  = item.compare_at_price ? item.compare_at_price * item.quantity : 0;
      var pHtml = orig > sub
        ? '<span class="cart-item__price-now">' + money(sub) + '</span><span class="cart-item__price-was">' + money(orig) + '</span>'
        : '<span class="cart-item__price-now">' + money(sub) + '</span>';
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="" loading="lazy" width="80" height="80">'
        : '<div class="cart-item__no-img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>';
      return (
        '<div class="cart-item" data-key="' + key + '">' +
          '<a href="' + item.url + '" class="cart-item__thumb">' + imgHtml + '</a>' +
          '<div class="cart-item__info">' +
            '<a href="' + item.url + '" class="cart-item__name">' + (item.product_title || item.title) + '</a>' +
            (vt ? '<span class="cart-item__variant">' + vt + '</span>' : '') +
            '<div class="cart-item__price">' + pHtml + '</div>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" onclick="window.PATTE._changeQty(\'' + key + '\',-1)" type="button" aria-label="Minder">−</button>' +
              '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" onclick="window.PATTE._changeQty(\'' + key + '\',1)" type="button" aria-label="Meer">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item__remove" onclick="window.PATTE.setQty(\'' + key + '\',0)" type="button" aria-label="Verwijder">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>'
      );
    };

    /* empty state */
    P._renderEmptyCart = function () {
      return (
        '<div class="cart-empty">' +
          '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="var(--c-primary)" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '<p class="cart-empty__msg">Je winkelmandje is nog leeg.</p>' +
          '<div class="cart-empty__ctas">' +
            '<a href="/collections/honden" class="btn btn--primary">Honden</a>' +
            '<a href="/collections/katten" class="btn btn--secondary">Katten</a>' +
            '<a href="/collections/summer-sale" class="btn btn--ghost">Sale</a>' +
          '</div>' +
        '</div>'
      );
    };

    /* cart footer */
    P._renderFoot = function () {
      var sub   = this._subtotal();
      var disc  = this.computeDiscount();
      var ship  = this.computeShipping();
      var total = this.computeTotal();
      var n     = this._itemCount();

      var discLine = disc > 0
        ? '<div class="cart-foot__row cart-foot__row--discount"><span>Bundelkorting (' + Math.round(BPCT * 100) + '% op ' + BMIN + '+ items)</span><span>−' + money(disc) + '</span>'+
          '</div>'
        : '';
      var shipLabel = ship === 0 ? '<strong>Gratis 🎉</strong>' : money(ship);

      return (
        '<div class="cart-foot__lines">' +
          '<div class="cart-foot__row"><span>Subtotaal (' + n + ' item' + (n !== 1 ? 's' : '') + ')</span><span>' + money(sub) + '</span></div>' +
          discLine +
          '<div class="cart-foot__row"><span>Verzending</span><span>' + shipLabel + '</span></div>' +
          '<div class="cart-foot__row cart-foot__row--total"><span>Totaal</span><span>' + money(total) + '</span></div>' +
        '</div>' +
        '<div class="cart-foot__trust">' +
          '<span class="trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> Veilig betalen</span>' +
          '<span class="trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg> Binnen 30 dagen retour</span>' +
          '<span class="trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Snel geleverd</span>' +
        '</div>' +
        '<div class="cart-foot__pay">' +
          '<span class="pay-icon pay-icon--ideal">iDEAL</span>' +
          '<span class="pay-icon pay-icon--klarna">Klarna</span>' +
          '<span class="pay-icon pay-icon--visa">VISA</span>' +
          '<span class="pay-icon pay-icon--mc">MC</span>' +
        '</div>' +
        '<div class="cart-foot__cta">' +
          '<a href="/cart" class="btn btn--secondary cart-foot__view-cart">Bekijk winkelmandje</a>' +
          '<a href="/checkout" class="btn btn--primary cart-foot__checkout">Afrekenen →</a>' +
        '</div>' +
        '<p class="cart-foot__note">Verzendkosten en kortingen worden berekend bij afrekenen.</p>'
      );
    };

    /* upsell via Product Recommendations API */
    P._renderUpsell = function () {
      var uEl   = document.getElementById('cartUpsell');
      if (!uEl) return;
      var items = this.cart || [];
      if (items.length === 0) { uEl.innerHTML = ''; return; }

      var firstId  = items[0].product_id;
      var cartIds  = items.map(function (i) { return i.product_id; });

      fetch('/recommendations/products.json?product_id=' + firstId + '&limit=6&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data.products || [])
            .filter(function (p) { return cartIds.indexOf(p.id) === -1; })
            .slice(0, 3);
          if (prods.length === 0) { uEl.innerHTML = ''; return; }

          var html = '<div class="cart-upsell"><h4 class="cart-upsell__title">Misschien ook leuk</h4><div class="cart-upsell__grid">';
          prods.forEach(function (p) {
            var v = p.variants && p.variants[0];
            if (!v) return;
            /* featured_image is a plain string-URL in the Recommendations API — never an object */
            var imgSrc = typeof p.featured_image === 'string'
              ? p.featured_image
              : (p.featured_image && p.featured_image.src) || '';
            /* append Shopify CDN width param for a 56px thumbnail */
            if (imgSrc) {
              imgSrc = imgSrc.indexOf('?') !== -1
                ? imgSrc.replace(/[?&](width|height|crop)=[^&]*/g, '') + '&width=56'
                : imgSrc + '?width=56';
            }
            var imgHtml = imgSrc
              ? '<img class="cart-upsell__img" src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="56" height="56">'
              : '<div class="cart-upsell__no-img" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>';
            html += (
              '<div class="cart-upsell__item">' +
                imgHtml +
                '<div class="cart-upsell__info">' +
                  '<span class="cart-upsell__name">' + p.title + '</span>' +
                  '<span class="cart-upsell__price">€ ' + (v.price / 100).toFixed(2).replace('.', ',') + '</span>' +
                '</div>' +
                '<button class="cart-upsell__btn" onclick="window.PATTE.addToCart(' + v.id + ',this)" type="button" aria-label="' + p.title.replace(/"/g, '&quot;') + ' toevoegen">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                '</button>' +
              '</div>'
            );
          });
          html += '</div></div>';
          uEl.innerHTML = html;
        })
        .catch(function () { uEl.innerHTML = ''; });
    };

    /* homepage quick-add: knoppen met data-variant-id → echte Shopify-stroom, geen toast */
    (function () {
      var _orig = P.addByName.bind(P);
      var _skip = false;

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-atc[data-variant-id]');
        if (!btn) return;
        _skip = true;
        setTimeout(function () { _skip = false; }, 0);
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!vid || !window.routes || !window.routes.cart_add_url) return;
        btn.disabled = true;
        var origHtml = btn.innerHTML;
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.PATTE.openCart();
          window.PATTE.loadCart();
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="16" height="16"><path d="M20 6L9 17l-5-5"/></svg>';
          setTimeout(function () { btn.innerHTML = origHtml; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.disabled = false; btn.innerHTML = origHtml; });
      }, true);

      /* fallback voor producten zonder variantId (demo-only, geen Shopify-koppeling) */
      P.addByName = function (name) {
        var self = this;
        if (_skip) { _skip = false; return; }
        var _origShow = self.showToast;
        self.showToast = function () {};
        _orig(name);
        self.showToast = _origShow;
        setTimeout(function () { self.loadCart(); }, 350);
      };
    })();

    /* recently viewed — called from product pages */
    P.trackRecentlyViewed = function (product) {
      if (!product || !product.id) return;
      try {
        var list = JSON.parse(localStorage.getItem('furleza_rv') || '[]');
        list = list.filter(function (p) { return p.id !== product.id; });
        list.unshift(product);
        localStorage.setItem('furleza_rv', JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    };

    P.renderRecentlyViewed = function (container) {
      if (!container) return;
      try {
        var list = JSON.parse(localStorage.getItem('furleza_rv') || '[]');
        if (!list.length) { container.style.display = 'none'; return; }
        var html = '<section class="rv-section"><h2 class="rv-section__title">Onlangs bekeken</h2><div class="rv-grid">';
        list.slice(0, 6).forEach(function (p) {
          html +=
            '<a href="' + p.url + '" class="rv-card">' +
              (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="120" height="120">' : '') +
              '<span class="rv-card__title">' + (p.title || '') + '</span>' +
              '<span class="rv-card__price">€ ' + ((p.price || 0) / 100).toFixed(2).replace('.', ',') + '</span>' +
            '</a>';
        });
        html += '</div></section>';
        container.innerHTML = html;
        container.style.display = '';
      } catch (e) { container.style.display = 'none'; }
    };

    /* boot */
    P.loadCart();
  }

  ready(function () {
    if (window.PATTE) { patchPATTE(); return; }
    var n = 0;
    var t = setInterval(function () {
      if (window.PATTE || n++ > 40) { clearInterval(t); patchPATTE(); }
    }, 100);
  });
})();

/* Scroll-lock: achtergrondpagina niet laten meescrollen als het winkelmandje open is (iOS-proof) */
(function () {
  'use strict';
  var lockY = 0;
  var locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    lockY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -lockY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    window.scrollTo(0, lockY);
  }
  function patch() {
    var P = window.PATTE;
    if (!P || typeof P.openCart !== 'function') { setTimeout(patch, 200); return; }
    var _open = P.openCart.bind(P);
    var _close = P.closeCart.bind(P);
    P.openCart = function () { _open(); lock(); };
    P.closeCart = function () { _close(); unlock(); };
    /* al open bij laden? (edge case) */
    if (P.cartOpen) lock();
  }
  if (document.readyState !== 'loading') { patch(); }
  else { document.addEventListener('DOMContentLoaded', patch); }
})();
